import httpService from '@/services/HttpService';
import {UserResponse} from '@/models/UserResponse';
import {UserRequest} from '@/models/UserRequest';

const baseApiPath = process.env.VUE_APP_API_PATH || '';

export class UserService {

    public async _resendEmail(request: UserRequest): Promise<UserRequest> {
        const response = await httpService.axios.post<UserRequest>(
            baseApiPath + '/api/user/resend-email',
            request);
        return response.data;
    }

    public async resendEmail(request: UserRequest, token: string): Promise<UserResponse> {
        const response = await httpService.axios.post<UserResponse>(
            baseApiPath + '/api/user/resend-email',
            request,
            {headers: this.createHeaders(token)});
        return response.data;
    }

    private createHeaders(token: string): any {
        return {
            'omni-client-register': token
        };
    }
}

const userService = new UserService();
export default userService;

